import {
  $serializer_getInstance2m8ynx42p4oox as $serializer_getInstance,
  $serializer_getInstance2jfn7wtddihen as $serializer_getInstance_0,
  $serializer_getInstance1a39stva24llm as $serializer_getInstance_1,
  $serializer_getInstance1dhvc4iof5db1 as $serializer_getInstance_2,
  $serializer_getInstance21thv1dv9fwx4 as $serializer_getInstance_3,
  ChildPlacement1fdgqwhgo48yv as ChildPlacement,
  IDqqik72jjbpsn as ID,
  ID1lyj7m2ox8cp5 as ID_0,
  Companion_instance11cvr3tzm4vi0 as Companion_instance,
  IDjecfjjw6mot9 as ID_1,
  ID1z61wlmtvxrjn as ID_2,
  ID1m87d1hextx54 as ID_3,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { today1rno4frfjp5oe as today } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/clock.mjs';
import {
  get_yearMonth3uo9i62rhbu6p as get_yearMonth,
  minusMonth2kfh16ajztknk as minusMonth,
} from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/YearMonth.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  SingleChildDayfsi906tc8dp6 as SingleChildDay,
  EmployerContribution22em0kfok1nyo as EmployerContribution,
  GrantContribution17s6i04gc835s as GrantContribution,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_voided2matvha0tyhkf as get_voided,
  get_forDate3tzeotrzulxwz as get_forDate,
  get_employerContributionsrrrn8wrmt5nc as get_employerContributions,
  get_employer10g54kx25vga3 as get_employer,
  get_grantContributionsaz7v0xwh5pzh as get_grantContributions,
  get_grant16jjr24y2ahic as get_grant,
  get_family3q4ofyk7cegoi as get_family,
  get_location293x913xs6wdd as get_location,
  get_provider3mtu6uzbh0coh as get_provider,
  get_activeRangedsifhrs4gcfc as get_activeRange,
  get_employers2nozrigfcaz4w as get_employers,
  get_grants3pvkn0u5vub3i as get_grants,
  get_familyraw6f29ztw22 as get_family_0,
  get_location1p3um6ao7ento as get_location_0,
  get_providerwos77hd4slhf as get_provider_0,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  eq353yrgcpovoi1 as eq,
  gte1zw995v5ulf70 as gte,
  lte2qmhlnwrclg8p as lte,
  xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import {
  and3dbt2f202um49 as and,
  SetAnyElements2se8zlywewplk as SetAnyElements,
  And1a3dbpwh0hxmu as And,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import {
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { maxOfnpw4mt1rg0hl as maxOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import { ClosedLocalDateRange6599xgap66zd as ClosedLocalDateRange } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { overlaps2e3dna24gi3hb as overlaps } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/dateRangeConditions.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { chipMultiselect24u6i0cuozpmn as chipMultiselect } from '../components/multiselect.mjs';
import {
  filterMenu2fz1h01y9a2vu as filterMenu,
  FilterChiptjf5vayz5x4r as FilterChip,
  filterChip1bkihjb9h4931 as filterChip,
} from '../components/filters.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ScrollView.commonHtml.js.mjs';
import { beforeSetup1a13mbd699ddp as beforeSetup } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ElementWriter.ext.mjs';
import { rowOf3phwx1yo72ntt as rowOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { modify3w2ijgzr8982m as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { minus27abgkurcn6u0 as minus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function ReportFilters$Companion$$childSerializers$_anonymous__2j5ohv() {
  return new (LinkedHashSetSerializer())($serializer_getInstance());
}
function ReportFilters$Companion$$childSerializers$_anonymous__2j5ohv_0() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_0());
}
function ReportFilters$Companion$$childSerializers$_anonymous__2j5ohv_1() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_1());
}
function ReportFilters$Companion$$childSerializers$_anonymous__2j5ohv_2() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_2());
}
function ReportFilters$Companion$$childSerializers$_anonymous__2j5ohv_3() {
  return new (LinkedHashSetSerializer())($serializer_getInstance_3());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, ReportFilters$Companion$$childSerializers$_anonymous__2j5ohv);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, ReportFilters$Companion$$childSerializers$_anonymous__2j5ohv_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_5 = lazy(tmp_4, ReportFilters$Companion$$childSerializers$_anonymous__2j5ohv_1);
        var tmp_6 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_7 = lazy(tmp_6, ReportFilters$Companion$$childSerializers$_anonymous__2j5ohv_2);
        var tmp_8 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, tmp_1, tmp_3, tmp_5, tmp_7, lazy(tmp_8, ReportFilters$Companion$$childSerializers$_anonymous__2j5ohv_3)];
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.reports.ReportFilters', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('start', true);
        tmp0_serialDesc.addElement_5pzumi_k$('endInclusive', true);
        tmp0_serialDesc.addElement_5pzumi_k$('employers', true);
        tmp0_serialDesc.addElement_5pzumi_k$('grants', true);
        tmp0_serialDesc.addElement_5pzumi_k$('families', true);
        tmp0_serialDesc.addElement_5pzumi_k$('locations', true);
        tmp0_serialDesc.addElement_5pzumi_k$('providers', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_r6f01u_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !value.start_1.equals(minusMonth(get_yearMonth(today())).get_firstDay_u4rr11_k$())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), value.start_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !value.endInclusive_1.equals(minusMonth(get_yearMonth(today())).get_lastDay_hikhp_k$())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), value.endInclusive_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.employers_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.employers_1);
        }
        var tmp_0;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3)) {
          tmp_0 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$1 = emptySet();
          tmp_0 = !equals(value.grants_1, tmp$ret$1);
        }
        if (tmp_0) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.grants_1);
        }
        var tmp_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4)) {
          tmp_1 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$2 = emptySet();
          tmp_1 = !equals(value.families_1, tmp$ret$2);
        }
        if (tmp_1) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), value.families_1);
        }
        var tmp_2;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5)) {
          tmp_2 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$3 = emptySet();
          tmp_2 = !equals(value.locations_1, tmp$ret$3);
        }
        if (tmp_2) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 5, tmp2_cached[5].get_value_j01efc_k$(), value.locations_1);
        }
        var tmp_3;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6)) {
          tmp_3 = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$4 = emptySet();
          tmp_3 = !equals(value.providers_1, tmp$ret$4);
        }
        if (tmp_3) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 6, tmp2_cached[6].get_value_j01efc_k$(), value.providers_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_r6f01u_k$(encoder, value instanceof ReportFilters() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp12_cached = Companion_getInstance_0().$childSerializers_1;
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp12_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp12_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp12_cached[4].get_value_j01efc_k$(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp12_cached[5].get_value_j01efc_k$(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp12_cached[6].get_value_j01efc_k$(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp12_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp12_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp12_cached[4].get_value_j01efc_k$(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 5, tmp12_cached[5].get_value_j01efc_k$(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 6, tmp12_cached[6].get_value_j01efc_k$(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ReportFilters().new_org_thecommunitygroupinc_cares_views_reports_ReportFilters_991yi8_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_0().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [LocalDateSerializer_getInstance(), LocalDateSerializer_getInstance(), tmp0_cached[2].get_value_j01efc_k$(), tmp0_cached[3].get_value_j01efc_k$(), tmp0_cached[4].get_value_j01efc_k$(), tmp0_cached[5].get_value_j01efc_k$(), tmp0_cached[6].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_4() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var ReportFiltersClass;
function ReportFilters() {
  if (ReportFiltersClass === VOID) {
    class $ {
      constructor(start, endInclusive, employers, grants, families, locations, providers) {
        Companion_getInstance_0();
        start = start === VOID ? minusMonth(get_yearMonth(today())).get_firstDay_u4rr11_k$() : start;
        endInclusive = endInclusive === VOID ? minusMonth(get_yearMonth(today())).get_lastDay_hikhp_k$() : endInclusive;
        var tmp;
        if (employers === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = employers;
        }
        employers = tmp;
        var tmp_0;
        if (grants === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        } else {
          tmp_0 = grants;
        }
        grants = tmp_0;
        var tmp_1;
        if (families === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_1 = emptySet();
        } else {
          tmp_1 = families;
        }
        families = tmp_1;
        var tmp_2;
        if (locations === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_2 = emptySet();
        } else {
          tmp_2 = locations;
        }
        locations = tmp_2;
        var tmp_3;
        if (providers === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_3 = emptySet();
        } else {
          tmp_3 = providers;
        }
        providers = tmp_3;
        this.start_1 = start;
        this.endInclusive_1 = endInclusive;
        this.employers_1 = employers;
        this.grants_1 = grants;
        this.families_1 = families;
        this.locations_1 = locations;
        this.providers_1 = providers;
      }
      toCondition_oj74tc_k$() {
        // Inline function 'com.lightningkite.services.database.condition' call
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp = serializerOrContextual(createKType(getKClass(SingleChildDay()), arrayOf([]), false));
        var tmp$ret$2 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        // Inline function 'kotlin.let' call
        var it = new (DataClassPathSelf())(tmp$ret$2);
        var tmp_0 = eq(get_voided(it), null);
        // Inline function 'com.lightningkite.services.database.condition' call
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp_1 = serializerOrContextual(createKType(getKClass(SingleChildDay()), arrayOf([]), false));
        var tmp$ret$7 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
        // Inline function 'kotlin.let' call
        var it_0 = new (DataClassPathSelf())(tmp$ret$7);
        var tmp_2 = and(gte(get_forDate(it_0), this.start_1), lte(get_forDate(it_0), this.endInclusive_1));
        // Inline function 'kotlin.takeIf' call
        var this_0 = this.employers_1;
        var tmp_3;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_0.isEmpty_y1axqb_k$()) {
          tmp_3 = this_0;
        } else {
          tmp_3 = null;
        }
        var tmp0_safe_receiver = tmp_3;
        var tmp_4;
        if (tmp0_safe_receiver == null) {
          tmp_4 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_5 = serializerOrContextual(createKType(getKClass(SingleChildDay()), arrayOf([]), false));
          var tmp$ret$17 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_1 = new (DataClassPathSelf())(tmp$ret$17);
          // Inline function 'com.lightningkite.services.database.any' call
          var this_1 = get_employerContributions(it_1);
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_6 = serializerOrContextual(createKType(getKClass(EmployerContribution()), arrayOf([]), false));
          var tmp$ret$22 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_2 = new (DataClassPathSelf())(tmp$ret$22);
          var tmp$ret$23 = xDataClassPathInsideSet(get_employer(it_2), tmp0_safe_receiver);
          tmp_4 = this_1.mapCondition_3hl8s3_k$(SetAnyElements().new_com_lightningkite_services_database_Condition_SetAnyElements_13dblj_k$(tmp$ret$23));
        }
        var tmp_7 = tmp_4;
        // Inline function 'kotlin.takeIf' call
        var this_2 = this.grants_1;
        var tmp_8;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_2.isEmpty_y1axqb_k$()) {
          tmp_8 = this_2;
        } else {
          tmp_8 = null;
        }
        var tmp1_safe_receiver = tmp_8;
        var tmp_9;
        if (tmp1_safe_receiver == null) {
          tmp_9 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_10 = serializerOrContextual(createKType(getKClass(SingleChildDay()), arrayOf([]), false));
          var tmp$ret$32 = isInterface(tmp_10, KSerializer()) ? tmp_10 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_3 = new (DataClassPathSelf())(tmp$ret$32);
          // Inline function 'com.lightningkite.services.database.any' call
          var this_3 = get_grantContributions(it_3);
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_11 = serializerOrContextual(createKType(getKClass(GrantContribution()), arrayOf([]), false));
          var tmp$ret$37 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_4 = new (DataClassPathSelf())(tmp$ret$37);
          var tmp$ret$38 = xDataClassPathInsideSet(get_grant(it_4), tmp1_safe_receiver);
          tmp_9 = this_3.mapCondition_3hl8s3_k$(SetAnyElements().new_com_lightningkite_services_database_Condition_SetAnyElements_13dblj_k$(tmp$ret$38));
        }
        var tmp_12 = tmp_9;
        // Inline function 'kotlin.takeIf' call
        var this_4 = this.families_1;
        var tmp_13;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_4.isEmpty_y1axqb_k$()) {
          tmp_13 = this_4;
        } else {
          tmp_13 = null;
        }
        var tmp2_safe_receiver = tmp_13;
        var tmp_14;
        if (tmp2_safe_receiver == null) {
          tmp_14 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_15 = serializerOrContextual(createKType(getKClass(SingleChildDay()), arrayOf([]), false));
          var tmp$ret$47 = isInterface(tmp_15, KSerializer()) ? tmp_15 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_5 = new (DataClassPathSelf())(tmp$ret$47);
          tmp_14 = xDataClassPathInsideSet(get_family(it_5), tmp2_safe_receiver);
        }
        var tmp_16 = tmp_14;
        // Inline function 'kotlin.takeIf' call
        var this_5 = this.locations_1;
        var tmp_17;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_5.isEmpty_y1axqb_k$()) {
          tmp_17 = this_5;
        } else {
          tmp_17 = null;
        }
        var tmp3_safe_receiver = tmp_17;
        var tmp_18;
        if (tmp3_safe_receiver == null) {
          tmp_18 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_19 = serializerOrContextual(createKType(getKClass(SingleChildDay()), arrayOf([]), false));
          var tmp$ret$57 = isInterface(tmp_19, KSerializer()) ? tmp_19 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_6 = new (DataClassPathSelf())(tmp$ret$57);
          tmp_18 = xDataClassPathInsideSet(get_location(it_6), tmp3_safe_receiver);
        }
        var tmp_20 = tmp_18;
        // Inline function 'kotlin.takeIf' call
        var this_6 = this.providers_1;
        var tmp_21;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_6.isEmpty_y1axqb_k$()) {
          tmp_21 = this_6;
        } else {
          tmp_21 = null;
        }
        var tmp4_safe_receiver = tmp_21;
        var tmp_22;
        if (tmp4_safe_receiver == null) {
          tmp_22 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_23 = serializerOrContextual(createKType(getKClass(SingleChildDay()), arrayOf([]), false));
          var tmp$ret$67 = isInterface(tmp_23, KSerializer()) ? tmp_23 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_7 = new (DataClassPathSelf())(tmp$ret$67);
          tmp_22 = xDataClassPathInsideSet(get_provider(it_7), tmp4_safe_receiver);
        }
        return And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOfNotNull([tmp_0, tmp_2, tmp_7, tmp_12, tmp_16, tmp_20, tmp_22]));
      }
      placementCondition_859kcq_k$() {
        // Inline function 'com.lightningkite.services.database.condition' call
        // Inline function 'com.lightningkite.services.database.path' call
        // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
        var tmp = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
        var tmp$ret$2 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
        // Inline function 'kotlin.let' call
        var it = new (DataClassPathSelf())(tmp$ret$2);
        var tmp_0 = overlaps(get_activeRange(it), new (ClosedLocalDateRange())(this.start_1, maxOf(this.start_1, this.endInclusive_1)));
        // Inline function 'kotlin.takeIf' call
        var this_0 = this.employers_1;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_0.isEmpty_y1axqb_k$()) {
          tmp_1 = this_0;
        } else {
          tmp_1 = null;
        }
        var tmp0_safe_receiver = tmp_1;
        var tmp_2;
        if (tmp0_safe_receiver == null) {
          tmp_2 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_3 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$12 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_0 = new (DataClassPathSelf())(tmp$ret$12);
          // Inline function 'com.lightningkite.services.database.any' call
          var this_1 = get_employers(it_0);
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_4 = serializerOrContextual(createKType(getKClass(ID()), arrayOf([]), false));
          var tmp$ret$17 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_1 = new (DataClassPathSelf())(tmp$ret$17);
          var tmp$ret$18 = xDataClassPathInsideSet(it_1, tmp0_safe_receiver);
          tmp_2 = this_1.mapCondition_3hl8s3_k$(SetAnyElements().new_com_lightningkite_services_database_Condition_SetAnyElements_13dblj_k$(tmp$ret$18));
        }
        var tmp_5 = tmp_2;
        // Inline function 'kotlin.takeIf' call
        var this_2 = this.grants_1;
        var tmp_6;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_2.isEmpty_y1axqb_k$()) {
          tmp_6 = this_2;
        } else {
          tmp_6 = null;
        }
        var tmp1_safe_receiver = tmp_6;
        var tmp_7;
        if (tmp1_safe_receiver == null) {
          tmp_7 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_8 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$27 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_2 = new (DataClassPathSelf())(tmp$ret$27);
          // Inline function 'com.lightningkite.services.database.any' call
          var this_3 = get_grants(it_2);
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_9 = serializerOrContextual(createKType(getKClass(ID_0()), arrayOf([]), false));
          var tmp$ret$32 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_3 = new (DataClassPathSelf())(tmp$ret$32);
          var tmp$ret$33 = xDataClassPathInsideSet(it_3, tmp1_safe_receiver);
          tmp_7 = this_3.mapCondition_3hl8s3_k$(SetAnyElements().new_com_lightningkite_services_database_Condition_SetAnyElements_13dblj_k$(tmp$ret$33));
        }
        var tmp_10 = tmp_7;
        // Inline function 'kotlin.takeIf' call
        var this_4 = this.families_1;
        var tmp_11;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_4.isEmpty_y1axqb_k$()) {
          tmp_11 = this_4;
        } else {
          tmp_11 = null;
        }
        var tmp2_safe_receiver = tmp_11;
        var tmp_12;
        if (tmp2_safe_receiver == null) {
          tmp_12 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_13 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$42 = isInterface(tmp_13, KSerializer()) ? tmp_13 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_4 = new (DataClassPathSelf())(tmp$ret$42);
          tmp_12 = xDataClassPathInsideSet(get_family_0(it_4), tmp2_safe_receiver);
        }
        var tmp_14 = tmp_12;
        // Inline function 'kotlin.takeIf' call
        var this_5 = this.locations_1;
        var tmp_15;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_5.isEmpty_y1axqb_k$()) {
          tmp_15 = this_5;
        } else {
          tmp_15 = null;
        }
        var tmp3_safe_receiver = tmp_15;
        var tmp_16;
        if (tmp3_safe_receiver == null) {
          tmp_16 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_17 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$52 = isInterface(tmp_17, KSerializer()) ? tmp_17 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_5 = new (DataClassPathSelf())(tmp$ret$52);
          tmp_16 = xDataClassPathInsideSet(get_location_0(it_5), tmp3_safe_receiver);
        }
        var tmp_18 = tmp_16;
        // Inline function 'kotlin.takeIf' call
        var this_6 = this.providers_1;
        var tmp_19;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this_6.isEmpty_y1axqb_k$()) {
          tmp_19 = this_6;
        } else {
          tmp_19 = null;
        }
        var tmp4_safe_receiver = tmp_19;
        var tmp_20;
        if (tmp4_safe_receiver == null) {
          tmp_20 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_21 = serializerOrContextual(createKType(getKClass(ChildPlacement()), arrayOf([]), false));
          var tmp$ret$62 = isInterface(tmp_21, KSerializer()) ? tmp_21 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_6 = new (DataClassPathSelf())(tmp$ret$62);
          tmp_20 = xDataClassPathInsideSet(get_provider_0(it_6), tmp4_safe_receiver);
        }
        return And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOfNotNull([tmp_0, tmp_5, tmp_10, tmp_14, tmp_18, tmp_20]));
      }
      ageGroupOf_ek8y4_k$(placement) {
        return Companion_instance.of_1hvtr1_k$(placement.childBirthDate_1, maxOf(placement.activeRange_1.start_1, this.start_1));
      }
      activeCount_htest3_k$() {
        var tmp0 = listOf([this.employers_1, this.grants_1, this.families_1, this.locations_1, this.providers_1]);
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.collections.count' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = 0;
            break $l$block;
          }
          var count = 0;
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!element.isEmpty_y1axqb_k$()) {
              count = count + 1 | 0;
              checkCountOverflow(count);
            }
          }
          tmp$ret$0 = count;
        }
        return tmp$ret$0;
      }
      copy_dgfmob_k$(start, endInclusive, employers, grants, families, locations, providers) {
        return new (ReportFilters())(start, endInclusive, employers, grants, families, locations, providers);
      }
      copy$default_x0hf9x_k$(start, endInclusive, employers, grants, families, locations, providers, $super) {
        start = start === VOID ? this.start_1 : start;
        endInclusive = endInclusive === VOID ? this.endInclusive_1 : endInclusive;
        employers = employers === VOID ? this.employers_1 : employers;
        grants = grants === VOID ? this.grants_1 : grants;
        families = families === VOID ? this.families_1 : families;
        locations = locations === VOID ? this.locations_1 : locations;
        providers = providers === VOID ? this.providers_1 : providers;
        return $super === VOID ? this.copy_dgfmob_k$(start, endInclusive, employers, grants, families, locations, providers) : $super.copy_dgfmob_k$.call(this, start, endInclusive, employers, grants, families, locations, providers);
      }
      toString() {
        return 'ReportFilters(start=' + this.start_1.toString() + ', endInclusive=' + this.endInclusive_1.toString() + ', employers=' + toString(this.employers_1) + ', grants=' + toString(this.grants_1) + ', families=' + toString(this.families_1) + ', locations=' + toString(this.locations_1) + ', providers=' + toString(this.providers_1) + ')';
      }
      hashCode() {
        var result = this.start_1.hashCode();
        result = imul(result, 31) + this.endInclusive_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.employers_1) | 0;
        result = imul(result, 31) + hashCode(this.grants_1) | 0;
        result = imul(result, 31) + hashCode(this.families_1) | 0;
        result = imul(result, 31) + hashCode(this.locations_1) | 0;
        result = imul(result, 31) + hashCode(this.providers_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ReportFilters()))
          return false;
        if (!this.start_1.equals(other.start_1))
          return false;
        if (!this.endInclusive_1.equals(other.endInclusive_1))
          return false;
        if (!equals(this.employers_1, other.employers_1))
          return false;
        if (!equals(this.grants_1, other.grants_1))
          return false;
        if (!equals(this.families_1, other.families_1))
          return false;
        if (!equals(this.locations_1, other.locations_1))
          return false;
        if (!equals(this.providers_1, other.providers_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_reports_ReportFilters_991yi8_k$(seen0, start, endInclusive, employers, grants, families, locations, providers, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_4().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.start_1 = minusMonth(get_yearMonth(today())).get_firstDay_u4rr11_k$();
        else
          $this.start_1 = start;
        if (0 === (seen0 & 2))
          $this.endInclusive_1 = minusMonth(get_yearMonth(today())).get_lastDay_hikhp_k$();
        else
          $this.endInclusive_1 = endInclusive;
        if (0 === (seen0 & 4)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.employers_1 = emptySet();
        } else
          $this.employers_1 = employers;
        if (0 === (seen0 & 8)) {
          var tmp_0 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_0.grants_1 = emptySet();
        } else
          $this.grants_1 = grants;
        if (0 === (seen0 & 16)) {
          var tmp_1 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_1.families_1 = emptySet();
        } else
          $this.families_1 = families;
        if (0 === (seen0 & 32)) {
          var tmp_2 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_2.locations_1 = emptySet();
        } else
          $this.locations_1 = locations;
        if (0 === (seen0 & 64)) {
          var tmp_3 = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp_3.providers_1 = emptySet();
        } else
          $this.providers_1 = providers;
        return $this;
      }
    }
    initMetadataForClass($, 'ReportFilters', ReportFilters, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
    ReportFiltersClass = $;
  }
  return ReportFiltersClass;
}
function reportFilterMenu(_this__u8e3s4, target) {
  var tmp = reportFilterMenu$slambda(target);
  return filterMenu(_this__u8e3s4, target, tmp, ($this$filterMenu) => {
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var label = 'Employer';
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$filterMenu.willAddChild_hz2iwc_k$(element);
    element.set_content_lzqutq_k$(label);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp = themed(element, FieldSemantic_getInstance());
    var tmp_0 = reportFilterMenu$lambda$lambda;
    var tmp_1 = target.lens_u4wb4z_k$(tmp_0, reportFilterMenu$lambda$lambda_0);
    var tmp_2 = remember(VOID, VOID, VOID, VOID, reportFilterMenu$lambda$lambda_1);
    chipMultiselect(tmp, tmp_1, tmp_2, reportFilterMenu$lambda$lambda_2, 'Showing all', Companion_getInstance().filterList_1);
    element.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    $this$filterMenu.willAddChild_hz2iwc_k$(element_0);
    element_0.set_content_lzqutq_k$('Grant');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp_3 = themed(element_0, FieldSemantic_getInstance());
    var tmp_4 = reportFilterMenu$lambda$lambda_3;
    var tmp_5 = target.lens_u4wb4z_k$(tmp_4, reportFilterMenu$lambda$lambda_4);
    var tmp_6 = remember(VOID, VOID, VOID, VOID, reportFilterMenu$lambda$lambda_5);
    chipMultiselect(tmp_3, tmp_5, tmp_6, reportFilterMenu$lambda$lambda_6, 'Showing all', Companion_getInstance().filterList_1);
    element_0.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element_0);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    $this$filterMenu.willAddChild_hz2iwc_k$(element_1);
    element_1.set_content_lzqutq_k$('Family');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp_7 = themed(element_1, FieldSemantic_getInstance());
    var tmp_8 = reportFilterMenu$lambda$lambda_7;
    var tmp_9 = target.lens_u4wb4z_k$(tmp_8, reportFilterMenu$lambda$lambda_8);
    var tmp_10 = remember(VOID, VOID, VOID, VOID, reportFilterMenu$lambda$lambda_9);
    chipMultiselect(tmp_7, tmp_9, tmp_10, reportFilterMenu$lambda$lambda_10, 'Showing all', Companion_getInstance().filterList_1);
    element_1.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var label_0 = 'Location of care';
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    $this$filterMenu.willAddChild_hz2iwc_k$(element_2);
    element_2.set_content_lzqutq_k$(label_0);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp_11 = themed(element_2, FieldSemantic_getInstance());
    var tmp_12 = reportFilterMenu$lambda$lambda_11;
    var tmp_13 = target.lens_u4wb4z_k$(tmp_12, reportFilterMenu$lambda$lambda_12);
    var tmp_14 = remember(VOID, VOID, VOID, VOID, reportFilterMenu$lambda$lambda_13);
    chipMultiselect(tmp_11, tmp_13, tmp_14, reportFilterMenu$lambda$lambda_14, 'Showing all', Companion_getInstance().filterList_1);
    element_2.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element_2);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var label_1 = 'Care provider';
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    $this$filterMenu.willAddChild_hz2iwc_k$(element_3);
    element_3.set_content_lzqutq_k$(label_1);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp_15 = themed(element_3, FieldSemantic_getInstance());
    var tmp_16 = reportFilterMenu$lambda$lambda_15;
    var tmp_17 = target.lens_u4wb4z_k$(tmp_16, reportFilterMenu$lambda$lambda_16);
    var tmp_18 = remember(VOID, VOID, VOID, VOID, reportFilterMenu$lambda$lambda_17);
    chipMultiselect(tmp_15, tmp_17, tmp_18, reportFilterMenu$lambda$lambda_18, 'Showing all', Companion_getInstance().filterList_1);
    element_3.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element_3);
    return Unit_instance;
  });
}
function reportFilterBar(_this__u8e3s4, filter) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var this_0 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_0.willAddChild_hz2iwc_k$(element_0);
  element_0.set_content_lzqutq_k$('From');
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
  var this_1 = themed(element_0, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (LocalDateField())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_1.willAddChild_hz2iwc_k$(element_1);
  var tmp = reportFilterBar$lambda;
  element_1.bind_gesskf_k$(element_1.content_1, filter.lens_u4wb4z_k$(tmp, reportFilterBar$lambda_0));
  element_1.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_1);
  element_0.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  var this_2 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_2.willAddChild_hz2iwc_k$(element_2);
  element_2.set_content_lzqutq_k$('To');
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
  var this_3 = themed(element_2, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (LocalDateField())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  this_3.willAddChild_hz2iwc_k$(element_3);
  var tmp_0 = reportFilterBar$lambda_1;
  element_3.bind_gesskf_k$(element_3.content_1, filter.lens_u4wb4z_k$(tmp_0, reportFilterBar$lambda_2));
  element_3.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_3);
  element_2.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_2);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  var chips = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var session = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull());
    var f = $this$remember.invoke_r7m7el_k$(filter);
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = f.employers_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var id = _iterator__ex2g4s.next_20eer_k$().raw_1;
      var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(session.get_employers_iw3lox_k$().get_6ueaa7_k$(new (ID())(id)));
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.name_1;
      var tmp = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
      this_0.add_utx5q5_k$(new (FilterChip())(new (ID())(id), tmp, reportFilterBar$lambda$slambda(filter, id)));
    }
    var _iterator__ex2g4s_0 = f.grants_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var id_0 = _iterator__ex2g4s_0.next_20eer_k$().raw_1;
      var tmp2_safe_receiver = $this$remember.invoke_r7m7el_k$(session.get_grants_dxrzz4_k$().get_6ueaa7_k$(new (ID_0())(id_0)));
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.name_1;
      var tmp_0 = tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs;
      this_0.add_utx5q5_k$(new (FilterChip())(new (ID_0())(id_0), tmp_0, reportFilterBar$lambda$slambda_0(filter, id_0)));
    }
    var _iterator__ex2g4s_1 = f.families_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
      var id_1 = _iterator__ex2g4s_1.next_20eer_k$().raw_1;
      var tmp4_safe_receiver = $this$remember.invoke_r7m7el_k$(session.get_families_is4v1x_k$().get_6ueaa7_k$(new (ID_1())(id_1)));
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.get_distinctName_5wyy9c_k$();
      var tmp_1 = tmp5_elvis_lhs == null ? '' : tmp5_elvis_lhs;
      this_0.add_utx5q5_k$(new (FilterChip())(new (ID_1())(id_1), tmp_1, reportFilterBar$lambda$slambda_1(filter, id_1)));
    }
    var _iterator__ex2g4s_2 = f.locations_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
      var id_2 = _iterator__ex2g4s_2.next_20eer_k$().raw_1;
      var tmp6_safe_receiver = $this$remember.invoke_r7m7el_k$(session.get_careLocations_f1rtw_k$().get_6ueaa7_k$(new (ID_2())(id_2)));
      var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.name_1;
      var tmp_2 = tmp7_elvis_lhs == null ? '' : tmp7_elvis_lhs;
      this_0.add_utx5q5_k$(new (FilterChip())(new (ID_2())(id_2), tmp_2, reportFilterBar$lambda$slambda_2(filter, id_2)));
    }
    var _iterator__ex2g4s_3 = f.providers_1.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
      var id_3 = _iterator__ex2g4s_3.next_20eer_k$().raw_1;
      var tmp8_safe_receiver = $this$remember.invoke_r7m7el_k$(session.get_careProviders_b5tc2w_k$().get_6ueaa7_k$(new (ID_3())(id_3)));
      var tmp9_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.name_1;
      var tmp_3 = tmp9_elvis_lhs == null ? '' : tmp9_elvis_lhs;
      this_0.add_utx5q5_k$(new (FilterChip())(new (ID_3())(id_3), tmp_3, reportFilterBar$lambda$slambda_3(filter, id_3)));
    }
    return this_0.build_nmwvly_k$();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.scrollingHorizontally' call
  // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
  var this_4 = themed(shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.invoke_r7m7el_k$(chips).isEmpty_y1axqb_k$();
  }), ListSemantic_getInstance());
  var vertical = false;
  var horizontal = true;
  var tmp_1 = beforeSetup(this_4, ($this$beforeSetup) => {
    (new (ScrollingBehaviorImpl())($this$beforeSetup, horizontal, vertical)).set_showScrollBars_vutwwi_k$(false);
    return Unit_instance;
  });
  var tmp_2 = reportFilterBar$lambda_3;
  var tmp_3 = reportFilterBar$lambda_4;
  rowOf(tmp_1, chips, tmp_2, VOID, tmp_3, reportFilterBar$lambda_5);
}
function reportFilterMenu$slambda$slambda() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return new (ReportFilters())(it.start_1, it.endInclusive_1);
  }), 1);
}
function reportFilterMenu$slambda($target) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* modify($target, reportFilterMenu$slambda$slambda(), $completion);
    return Unit_instance;
  }), 0);
}
function reportFilterMenu$lambda$lambda(it) {
  return it.employers_1;
}
function reportFilterMenu$lambda$lambda_0(old, it) {
  return old.copy$default_x0hf9x_k$(VOID, VOID, it);
}
function reportFilterMenu$lambda$lambda_1($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_employers_iw3lox_k$().query_so6xq1_k$(new (Query())(VOID, VOID, VOID, 2147483647)));
}
function reportFilterMenu$lambda$lambda_2(it) {
  return it.name_1;
}
function reportFilterMenu$lambda$lambda_3(it) {
  return it.grants_1;
}
function reportFilterMenu$lambda$lambda_4(old, it) {
  return old.copy$default_x0hf9x_k$(VOID, VOID, VOID, it);
}
function reportFilterMenu$lambda$lambda_5($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_grants_dxrzz4_k$().query_so6xq1_k$(new (Query())(VOID, VOID, VOID, 2147483647)));
}
function reportFilterMenu$lambda$lambda_6(it) {
  return it.name_1;
}
function reportFilterMenu$lambda$lambda_7(it) {
  return it.families_1;
}
function reportFilterMenu$lambda$lambda_8(old, it) {
  return old.copy$default_x0hf9x_k$(VOID, VOID, VOID, VOID, it);
}
function reportFilterMenu$lambda$lambda_9($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_families_is4v1x_k$().query_so6xq1_k$(new (Query())(VOID, VOID, VOID, 2147483647)));
}
function reportFilterMenu$lambda$lambda_10(it) {
  return it.get_distinctName_5wyy9c_k$();
}
function reportFilterMenu$lambda$lambda_11(it) {
  return it.locations_1;
}
function reportFilterMenu$lambda$lambda_12(old, it) {
  return old.copy$default_x0hf9x_k$(VOID, VOID, VOID, VOID, VOID, it);
}
function reportFilterMenu$lambda$lambda_13($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careLocations_f1rtw_k$().query_so6xq1_k$(new (Query())(VOID, VOID, VOID, 2147483647)));
}
function reportFilterMenu$lambda$lambda_14(it) {
  return it.name_1;
}
function reportFilterMenu$lambda$lambda_15(it) {
  return it.providers_1;
}
function reportFilterMenu$lambda$lambda_16(old, it) {
  return old.copy$default_x0hf9x_k$(VOID, VOID, VOID, VOID, VOID, VOID, it);
}
function reportFilterMenu$lambda$lambda_17($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$().query_so6xq1_k$(new (Query())(VOID, VOID, VOID, 2147483647)));
}
function reportFilterMenu$lambda$lambda_18(it) {
  return it.name_1;
}
function reportFilterBar$lambda(it) {
  return it.start_1;
}
function reportFilterBar$lambda_0(old, new_0) {
  return old.copy$default_x0hf9x_k$(new_0 == null ? old.start_1 : new_0);
}
function reportFilterBar$lambda_1(it) {
  return it.endInclusive_1;
}
function reportFilterBar$lambda_2(old, new_0) {
  return old.copy$default_x0hf9x_k$(VOID, new_0 == null ? old.endInclusive_1 : new_0);
}
function reportFilterBar$lambda$slambda$slambda($id) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_x0hf9x_k$(VOID, VOID, minus(it.employers_1, new (ID())($id)));
  }), 1);
}
function reportFilterBar$lambda$slambda($filter, $id) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, reportFilterBar$lambda$slambda$slambda($id), $completion);
    return Unit_instance;
  }), 1);
}
function reportFilterBar$lambda$slambda$slambda_0($id) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_x0hf9x_k$(VOID, VOID, VOID, minus(it.grants_1, new (ID_0())($id)));
  }), 1);
}
function reportFilterBar$lambda$slambda_0($filter, $id) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, reportFilterBar$lambda$slambda$slambda_0($id), $completion);
    return Unit_instance;
  }), 1);
}
function reportFilterBar$lambda$slambda$slambda_1($id) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_x0hf9x_k$(VOID, VOID, VOID, VOID, minus(it.families_1, new (ID_1())($id)));
  }), 1);
}
function reportFilterBar$lambda$slambda_1($filter, $id) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, reportFilterBar$lambda$slambda$slambda_1($id), $completion);
    return Unit_instance;
  }), 1);
}
function reportFilterBar$lambda$slambda$slambda_2($id) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_x0hf9x_k$(VOID, VOID, VOID, VOID, VOID, minus(it.locations_1, new (ID_2())($id)));
  }), 1);
}
function reportFilterBar$lambda$slambda_2($filter, $id) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, reportFilterBar$lambda$slambda$slambda_2($id), $completion);
    return Unit_instance;
  }), 1);
}
function reportFilterBar$lambda$slambda$slambda_3($id) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_x0hf9x_k$(VOID, VOID, VOID, VOID, VOID, VOID, minus(it.providers_1, new (ID_3())($id)));
  }), 1);
}
function reportFilterBar$lambda$slambda_3($filter, $id) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, reportFilterBar$lambda$slambda$slambda_3($id), $completion);
    return Unit_instance;
  }), 1);
}
function reportFilterBar$lambda_3(it) {
  return to(it.value_1, it.label_1);
}
function reportFilterBar$lambda_4($this$rowOf) {
  return get_centered($this$rowOf);
}
function reportFilterBar$lambda_5($this$rowOf, item) {
  var tmp = lens(item, reportFilterBar$lambda$lambda);
  filterChip($this$rowOf, tmp, VOID, reportFilterBar$lambda$slambda_4(item));
  return Unit_instance;
}
function reportFilterBar$lambda$lambda(it) {
  return it.label_1;
}
function reportFilterBar$lambda$slambda_4($item) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $item;
    yield* (yield* await_0(this_0, $completion)).remove_94srgz_k$($completion);
    return Unit_instance;
  }), 0);
}
//region block: exports
export {
  ReportFilters as ReportFiltersigb451dg4asm,
  reportFilterBar as reportFilterBar2ow9csmm0mu97,
  reportFilterMenu as reportFilterMenu2u8jz7auzgjn6,
};
//endregion

//# sourceMappingURL=ReportFilters.mjs.map
